import { Box } from "@chakra-ui/react";
import DatePickerReact, { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale";
import { forwardRef } from "react";

import "react-datepicker/dist/react-datepicker.css";

registerLocale("es", es);

export type DatePickerProps = {
  value?: Date | null;
  onChange?: (d: Date) => void;
  maxDate?: Date | null;
  minDate?: Date | null;
  placeHolder?: string;
};

export const DatePicker = forwardRef<HTMLDivElement, DatePickerProps>(
  ({ value, onChange = () => null, maxDate, minDate, placeHolder }, ref) => {
    return (
      <Box
        ref={ref}
        w="full"
        css={{
          "& .react-datepicker-wrapper, & .react-datepicker__input-container": {
            width: "100%",
          },
          "& input": {
            width: "100%",
            height: "40px",
            paddingInline: "12px",
            borderWidth: "1px",
            borderColor: "border",
            borderRadius: "l2",
            background: "bg",
            fontSize: "sm",
            outline: "none",
            transition: "border-color 0.15s, box-shadow 0.15s",
            _placeholder: { color: "fg.muted" },
            _focus: {
              borderColor: "brand.500",
              boxShadow: "0 0 0 1px var(--chakra-colors-brand-500)",
            },
          },
          "& .react-datepicker-popper": { zIndex: 30 },
          "& .react-datepicker": {
            background: "bg.panel",
            color: "fg",
            borderColor: "border",
          },
          "& .react-datepicker__header": {
            background: "bg.subtle",
            borderColor: "border",
          },
          "& .react-datepicker__current-month, & .react-datepicker__day-name, & .react-datepicker__day, & .react-datepicker-time__header, & .react-datepicker__time-list-item":
            { color: "fg" },
          "& .react-datepicker__day:hover, & .react-datepicker__time-list-item:hover":
            { background: "bg.muted" },
          "& .react-datepicker__day--selected, & .react-datepicker__day--keyboard-selected":
            { background: "brand.solid", color: "brand.contrast" },
          "& .react-datepicker__day--outside-month, & .react-datepicker__day--disabled":
            { color: "fg.subtle" },
          "& .react-datepicker__time-container, & .react-datepicker__time, & .react-datepicker__time-box":
            { background: "bg.panel", borderColor: "border" },
        }}
      >
        <DatePickerReact
          selected={value}
          locale="es"
          placeholderText={placeHolder}
          onChange={onChange}
          dateFormat={"dd/MM/yyyy"}
          maxDate={maxDate}
          minDate={minDate}
        />
      </Box>
    );
  },
);
